import { isInViewport } from '/web/app/themes/umdoisesportes/assets/scripts/common/functions'

const toggleVisibility = (block) => {
  if (isInViewport(block, 45) && !block.classList.contains('is-visible')) {
    block.classList.add('is-visible')
  }
}

export const initCasinoDataBlock = () => {
  const blocks = document.querySelectorAll('.block-acf---casino-data:not(.is-init)')
  if (!blocks.length) return

  blocks.forEach((block) => {
    block.classList.add('is-init')

    toggleVisibility(block)

    window.addEventListener('scroll', () => {
      toggleVisibility(block)
    })
  })
}

initCasinoDataBlock()
